import { Observable, Subscriber } from 'rxjs';

/**
 * An Observable<null> to be returned instead of creating new observables every time.
 *
 * @see https://github.com/ReactiveX/rxjs/blob/6.5.4/src/internal/observable/empty.ts
 * @see https://github.com/ReactiveX/rxjs/blob/6.5.4/src/internal/observable/never.ts
 */
export const NULL: Observable<null> = new Observable<null>((subscriber: Subscriber<null>): void => {
  subscriber.next(null);
  subscriber.complete();
});
